const OIDC_AUTHORITY = import.meta.env.VITE_OIDC_AUTHORITY;
const OIDC_CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID;

if (!OIDC_AUTHORITY?.trim()) {
  throw new Error(
    `[Env Config Error] Missing required env var: VITE_OIDC_AUTHORITY.
Current mode: ${import.meta.env.MODE || "unknown"}.
Ensure it's defined in the correct .env file and starts with VITE_.`,
  );
}

if (!OIDC_CLIENT_ID?.trim()) {
  throw new Error(
    `[Env Config Error] Missing required env var: VITE_OIDC_CLIENT_ID.
Current mode: ${import.meta.env.MODE || "unknown"}.
Ensure it's defined in the correct .env file and starts with VITE_.`,
  );
}

export const sentinelConfig = {
  authority: OIDC_AUTHORITY.trim(),
  client_id: OIDC_CLIENT_ID.trim(),
  redirect_uri: `${window.location.origin}/template-studio-ui/`,
  response_type: "code",
  scope: "openid profile email",
  post_logout_redirect_uri: `${window.location.origin}/logout`,
  // Token renewal is handled by verifyToken/refreshToken so refresh-token
  // rotation cannot race with oidc-client-ts silent renewal.
  automaticSilentRenew: true,
  // Refresh 65 minutes before a two-hour token expires (approximately 55 minutes after iat).
  //accessTokenExpiringNotificationTimeInSeconds: 65 * 60,
  silent_redirect_uri: `${window.location.origin}/template-studio-ui/`,
  extraQueryParams: {
    kc_idp_hint: "uhg-ms-id",
  },
} as const;

export default sentinelConfig;
